/**
 * A clinic's portal credentials (Revolution EHR, VSP, EyeMed). The backend
 * stores the password in Secret Manager; nothing here reads one back.
 */
import { httpsCallable } from 'firebase/functions'
import { functions } from '../config'
import type { IntegrationType } from '../types'

export interface SaveIntegrationCredentialsInput {
  orgId: string
  clinicId: string | null
  integrationType: IntegrationType
  username: string
  password: string
  /** Revolution EHR only: the practice's location name. */
  clinic?: string
}

export async function saveIntegrationCredentials(input: SaveIntegrationCredentialsInput): Promise<void> {
  const fn = httpsCallable<SaveIntegrationCredentialsInput, unknown>(functions, 'saveIntegrationCredentials')
  await fn(input)
}

export async function deleteIntegrationCredentials(input: {
  orgId: string
  clinicId: string
  integrationType: IntegrationType
}): Promise<void> {
  const fn = httpsCallable<typeof input, unknown>(functions, 'deleteIntegrationCredentials')
  await fn(input)
}
